import React from 'react';
import { 
    Box, 
    TextField, 
    Typography, 
    Stack 
} from '@mui/material';

interface DeltaTSectionProps {
    label: string;
    topValue: number | '';
    bottomValue: number | '';
    avgDeltaT: number;
    onTopChange: (value: number | '') => void;
    onBottomChange: (value: number | '') => void;
    isMobile?: boolean;
}

const DeltaTSection: React.FC<DeltaTSectionProps> = ({
    label,
    topValue,
    bottomValue,
    avgDeltaT,
    onTopChange,
    onBottomChange,
    isMobile = false,
}) => {
    return (
        <Box sx={{ mb: isMobile ? 2 : 2 }}>
            <Typography 
                variant={isMobile ? "caption" : "subtitle2"} 
                sx={{ mb: isMobile ? 1 : 0.5, fontWeight: 600, color: 'text.primary' }}
            >
                {label}
            </Typography>
            <Stack direction="row" spacing={isMobile ? 1.5 : 1}>
                <TextField
                    fullWidth
                    size="small"
                    label="Top"
                    type="number"
                    value={topValue}
                    onChange={(e) => onTopChange(e.target.value === '' ? '' : parseFloat(e.target.value))}
                    inputProps={{ step: 0.1 }}
                />
                <TextField
                    fullWidth
                    size="small"
                    label="Bottom"
                    type="number"
                    value={bottomValue}
                    onChange={(e) => onBottomChange(e.target.value === '' ? '' : parseFloat(e.target.value))}
                    inputProps={{ step: 0.1 }}
                />
                <TextField
                    fullWidth
                    size="small"
                    label="Avg ΔT"
                    value={avgDeltaT.toFixed(2)}
                    InputProps={{ readOnly: true }}
                    sx={{ 
                        '& .MuiInputBase-input': { 
                            backgroundColor: 'action.hover',
                            color: 'text.primary',
                            fontWeight: 600 
                        } 
                    }}
                />
            </Stack>
        </Box>
    );
};

export default DeltaTSection;
